import React, { useState } from "react";
import { func, object, bool } from "prop-types";
import { Formik, Form } from "formik";
import { Row, Col } from "reactstrap";

import MonitoringQueueEntrySearchDetailsTable from "./table";
import ChangeWatchlistEntryMatchStatusModal from "../change-watchlist-entry-match-status-modal/ChangeWatchlistEntryMatchStatusModal";

import SaveWatchlistIgnoringPropertiesModal from "../save-watchlist-ignoring-properties-modal/SaveWatchlistIgnoringPropertiesModal";

import { WATCHLIST_URLS } from "../../../../watch-list-entry/constants/watchListEntryConstants";
import { useDispatch, useSelector } from "react-redux";
import {
  setChangeDecisionDetails,
  toggleMQDecisionModal,
} from "../../../actions/changeDecisionModalsActions";
import {
  selectDetailsChangeDecision,
  selectModalMQChangeDecisionOpen,
} from "../../../selectors/changeDecisionModalsSelector";

const MonitoringQueueEntrySearchDetailsForm = ({
  handleSubmit,
  details,
  handleConfirm,
  permitConfirm,
  setDataChange,
}) => {
  const dispatch = useDispatch();
  const isOpenDetails = useSelector(selectModalMQChangeDecisionOpen());
  const entryDetails = useSelector(selectDetailsChangeDecision());
  const [isOpenSave, setIsOpenSave] = useState(false);

  const [initialValues, setInitialValues] = useState({
    entryStatus: 0,
    comment: "test",
  });

  const toggleDetails = (entry) => {
    dispatch(setChangeDecisionDetails(entry));
    dispatch(toggleMQDecisionModal(!isOpenDetails));
    setInitialValues({ entryStatus: 0 });
  };

  const toggleSaveModal = () => {
    setIsOpenSave(!isOpenSave);
  };

  return (
    <React.Fragment>
      <Formik
        onSubmit={handleSubmit}
        initialValues={initialValues}
        enableReinitialize
        permitConfirm
      >
        <Form className="monitoring-queue-entry-details-form">
          {details && (
            <React.Fragment>
              <Row>
                <Col lg={12}>
                  <MonitoringQueueEntrySearchDetailsTable
                    details={details}
                    toggleDetails={toggleDetails}
                    toggleSave={toggleSaveModal}
                    permitConfirm={permitConfirm}
                  />
                </Col>
              </Row>
              <SaveWatchlistIgnoringPropertiesModal
                toggle={toggleSaveModal}
                isOpen={isOpenSave}
                handleSubmit={handleSubmit}
              />
            </React.Fragment>
          )}
        </Form>
      </Formik>

      <ChangeWatchlistEntryMatchStatusModal
        toggle={() => toggleDetails(entryDetails)}
        details={entryDetails}
        alldetails={details}
        handleConfirm={handleConfirm}
        type={details.type}
        setDataChange={setDataChange}
        url={
          entryDetails
            ? entryDetails.url || WATCHLIST_URLS[entryDetails.name]
            : null
        }
      />
      <br />
      <br />
    </React.Fragment>
  );
};
MonitoringQueueEntrySearchDetailsForm.propTypes = {
  handleSubmit: func.isRequired,
  handleConfirm: func.isRequired,
  details: object.isRequired,
  permitConfirm: bool.isRequired,
  setDataChange: func.isRequired,
};

export default MonitoringQueueEntrySearchDetailsForm;



// WEBPACK FOOTER //
// ./src/features/monitoring-queue-entry/components/searching/search-details-form/MonitoringQueueEntrySearchDetailsForm.jsx